import List from "./pages/List";

const routes = [
  {
    path: "*",
    element: List,
  },
];

export default routes;
